import React, { SyntheticEvent, useContext, useEffect, useState } from "react";
import DropdownWithCheckboxMenu from "../../../../../../../components/DropdownWithCheckboxMenu";
import { PUBLIC_URL } from "../../../../../../App/configs/Constants";
import { useDispatch, useSelector } from "react-redux";
import { dashboardDayOfficeBookingFilterAction } from "../../../../../actions/DashboardActions";
import {
  BUSINESS,
  DAY_OFFICE_BOOKING_ALL_STATUS,
  DAY_OFFICE_BOOKING_CANCELLED_STATUS,
  DAY_OFFICE_BOOKING_COMPLETED_STATUS,
  DAY_OFFICE_BOOKING_CONFIRMED_STATUS,
  DAY_OFFICE_BOOKING_DECLINED_STATUS,
  DAY_OFFICE_BOOKING_PENDING_STATUS,
  DAY_OFFICE_BOOKING_REFUND_FILTER,
} from "../../../../../configs/Constants";
import {
  dashboardFilterDateRangeSelector,
  dashboardDayOfficeBookingFilterSelector,
} from "../../../../../selectors/DashboardSelectors";
import { LocalizationContext } from "../../../../../../../locales/Translation";
import { createDayOfficeBookingStatusFilterService } from "../../../../../services/DashboardServices";

type Props = {
  productType?: number;
};

const FilterDayOfficeBooking = ({ productType }: Props) => {
  const { translations } = useContext(LocalizationContext);

  const dispatch = useDispatch();
  const dashboardDayOfficeBookingFilter = useSelector(
    dashboardDayOfficeBookingFilterSelector
  );
  const dashboardFilterDateRange = useSelector(
    dashboardFilterDateRangeSelector
  );

  const [dayOfficeBookingStatus, setDayOfficeBookingStatus] = useState<
    { id: string; name: string }[]
  >([]);

  useEffect(() => {
    (async () => {
      try {
        if (dashboardFilterDateRange === null) {
          return;
        }
        await createDayOfficeBookingStatusFilterService({
          translations,
          setStatus: setDayOfficeBookingStatus,
          type: BUSINESS,
          productType,
        });
      } catch (e) {
        console.log("e", e);
      }
    })();
  }, [dashboardDayOfficeBookingFilter?.keyword, dashboardFilterDateRange]);

  const _onChangeFilter = (_: SyntheticEvent, data: any) => {
    if (data.value === DAY_OFFICE_BOOKING_ALL_STATUS) {
      if (data.checked) {
        dispatch(
          dashboardDayOfficeBookingFilterAction({
            key: "filter_status",
            value: [
              DAY_OFFICE_BOOKING_ALL_STATUS,
              DAY_OFFICE_BOOKING_CONFIRMED_STATUS,
              DAY_OFFICE_BOOKING_PENDING_STATUS,
              DAY_OFFICE_BOOKING_DECLINED_STATUS,
              DAY_OFFICE_BOOKING_CANCELLED_STATUS,
              DAY_OFFICE_BOOKING_COMPLETED_STATUS,
            ],
          })
        );
      } else {
        dispatch(
          dashboardDayOfficeBookingFilterAction({
            key: "filter_status",
            value: [],
          })
        );
      }
      return;
    }

    if (data.checked) {
      if (DAY_OFFICE_BOOKING_REFUND_FILTER.includes(data.value)) {
        // const newValue = [
        //   ...dashboardDayOfficeBookingFilter.filter_refund_status,
        //   data.value,
        // ];
        // dispatch(
        //   dashboardDayOfficeBookingFilterAction({
        //     key: "filter_refund_status",
        //     value: newValue,
        //   })
        // );
      } else {
        const newValue = [
          ...dashboardDayOfficeBookingFilter.filter_status,
          data.value,
        ];
        dispatch(
          dashboardDayOfficeBookingFilterAction({
            key: "filter_status",
            value: newValue,
          })
        );
      }
      return;
    }

    const newValue = dashboardDayOfficeBookingFilter.filter_status.filter(
      (status: string) =>
        status !== data.value && status !== DAY_OFFICE_BOOKING_ALL_STATUS
    );
    dispatch(
      dashboardDayOfficeBookingFilterAction({
        key: "filter_status",
        value: newValue,
      })
    );
  };

  return (
    <div className={"dropdown-filter"}>
      <DropdownWithCheckboxMenu
        onChange={_onChangeFilter}
        listCheckBox={dayOfficeBookingStatus.map((filter: any) => {
          filter.checked =
            !!dashboardDayOfficeBookingFilter.filter_status.includes(filter.id);

          return filter;
        })}
        label={translations.filters}
        icon={
          <img
            alt={"Deskimo"}
            src={PUBLIC_URL + "/assets/icons/icon-filter.svg"}
          />
        }
      />
    </div>
  );
};

export default FilterDayOfficeBooking;
